import React, { useState, useEffect } from "react";
import WhyAptechImage from "../../../assets/images/WhyAptech.jpg";
import ImageTextSection from "../../CustomComponent/ImageTextSection.tsx";
import styles from "./WhyAptech.module.scss";
import { Icon } from "../../../assets/Icons.tsx";

const WhyAptech: React.FC = () => {
  // const content = [
  //   `<strong>Aptech: Empowering Individuals, Strengthening Industries, Transforming Societies</strong>`,
  //   `For over <strong>39 years</strong>, Aptech has been at the forefront of <strong>vocational training</strong>, shaping millions of careers and driving industry growth worldwide.</strong>`,
  //   `<ul class="boldListMarkers">
  //     <li><strong>Global Reach: </strong>Presence in 40+ countries. </li>
  //     <li><strong>Industry-focused Training Verticals: </strong>Expertise in IT, Animation, Aviation, Beauty & Wellness, and Early Childhood Education.</li>
  //     <li><strong>Career Creation: </strong>Enabling thousands of employment opportunities in Animation, VFX, Beauty, IT, Aviation, and Hospitality, every year.</li>
  //     <li><strong>Testing and Training Solutions: </strong>Through ATTEST, Testing Solutions (TS), and Education Institutes and Corporates (EIC), delivering competency-driven corporate training to leading enterprises</li>
  //     <li><strong>Bridging Skill Gaps: </strong>Industry-aligned programs ensuring a future-ready workforce.</li>
  //           <li><strong>Societal Impact: </strong>Empowering individuals from diverse backgrounds with quality education and career opportunities.</li>

  //   </ul>`,
  //   `<strong class="mb-0">At Aptech, we believe that education that goes beyond classrooms. We are creating careers, fostering innovation, and building a skilled global workforce.</strong`,
  // ];
  // const firstRowRef = useRef<HTMLDivElement>(null);
  // const [firstRowVisible, setFirstRowVisible] = useState(false);

  const whyAptechData = [
    {
      title: "Global Reach",
      description: "Presence in 40+ countries.",
      icon: "globalSearch",
      mobIcon: "globalSearchMob",
    },
    {
      title: "Industry-focused Training Verticals",
      description:
        "Expertise in IT, Animation, Aviation, Beauty & Wellness, and Early Childhood Education.",
      icon: "industryVerticle",
      mobIcon: "industryVerticleMob",
    },
    {
      title: "Career Creation",
      description:
        "Enabling employment opportunities in Animation, VFX, Virtual Production, Beauty & Wellness, IT, Aviation, and Hospitality, every year.",
      icon: "careerCreation",
      mobIcon: "careerCreationMob",
    },
    {
      title: "Testing and Training Solutions",
      description:
        "Delivering competency-driven corporate training to leading enterprises.",
      icon: "testingSolution",
      mobIcon: "testingSolutionMob",
    },
    {
      title: "Bridging Skill Gap",
      description:
        "Industry-aligned programs ensuring a future-ready workforce.",
      icon: "skillGap",
      mobIcon: "skillGapMob",
    },
    {
      title: "Societal Impact",
      description:
        "Empowering individuals from diverse backgrounds with quality education and career opportunities.",
      icon: "societalImpact",
      mobIcon: "societalImpactMob",
    },
    // Add more as needed
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 765);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1080);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="WhyAptechPAge" className={styles.whyAptechPage}>
      <div className="container">
        <div className="section">
          <div className="row">
            <div className="col-12">
              <p className="heading text-center">A Legacy of Excellence</p>
            </div>
          </div>
          <div className={`row`}>
            <div className="col-12 d-flex flex-column justify-content-center align-items-center">
              <div className={`${styles.whyAptechPara}`}>
                <p className="para text-center">
                  <strong>
                    Aptech: Empowering Individuals, Strengthening Industries,
                    Transforming Societies
                  </strong>
                </p>
                <p className="para2 text-center">
                  For over 40+ years, Aptech has been at the forefront of
                  <a href="/our-businesses/domestic-retail">
                    {" "}
                    vocational training
                  </a>
                  , shaping lives of millions of students and professionals by
                  providing some of the best career opportunities and driving
                  industry growth worldwide.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {whyAptechData.map((item, index) => (
              <div
                className="col-xl-4 col-md-6 col-sm-12 col-12 mb-4 d-flex"
                key={index}
              >
                <div
                  className={`${styles.WhyAptechCard} w-100 d-flex justify-content-between`}
                >
                  <div className={styles.WhyAptechCardDiv}>
                    <p className="para" style={{ lineHeight: "inherit" }}>
                      <strong>{item.title}</strong>
                    </p>
                    <p className="para2 mb-0">{item.description}</p>
                  </div>
                  <div className={`text-end ${styles.icon}`}>
                    <Icon
                      name={isMobile ? item.mobIcon : item.icon}
                      width={isMobile ? "auto" : "110px"}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className={`row ${styles.whyAptechBottomPara}`}>
            <div className="col-12 text-center">
              <p
                className={`cardHeading text-center mb-1 ${styles.bottomParaText}`}
              >
                <strong>
                  At Aptech, we believe that education goes beyond
                  classrooms.{" "}
                </strong>
              </p>
              <p className="para2 text-center">
                We are creating careers, fostering innovation and building a
                skilled global workforce.
              </p>
            </div>
          </div>

          {/* <ImageTextSection
          imageSrc={WhyAptechImage}
          imageAlt="Aptech Image"
          content={content}
          colImageValue={4}
          colTextValue={8}
          contentPosition={true}
        /> */}
        </div>
      </div>
    </div>
  );
};

export default WhyAptech;
